export default __webpack_public_path__ + "static/media/5_MountainOfGems.509c23d2.png";